<template>
  <div id="account-container">
    <Header style="background-color: #fff"></Header>
    <section id="account">
      <div class="container">
        <div class="row justify-content-center">
          <div class="col-12">
            <div class="tab tab-btn">
              <button
                style="margin-right: 0.3rem;"
                class="tablinks"
                onclick="yearList(event, 'editProfile')"
              >
                <span>Edito Profilin</span>
                <i class="fa fa-user" aria-hidden="true"></i>
              </button>
              <button v-if="userType === 'client' || userType==='agent'"
                style="margin-right: 0.3rem"
                class="tablinks"
                onclick="yearList(event, 'invoices')"
              >
                <span>Permbledhja e pagesave</span>
                <i class="fa fa-credit-card" aria-hidden="true"></i>
              </button>
              <button v-if="userType === 'client' || userType==='agent'"
                style="margin-right: 0.3rem"
                class="tablinks"
                onclick="yearList(event, 'subscribe')"
              >
                <span>Anëtarësim</span>
                <i class="fa fa-archive" aria-hidden="true"></i>
              </button>
              <button
                style="margin-right: 0.3rem"
                class="tablinks active"
                onclick="yearList(event, 'passwordChange')"
              >
                <span>Ndrysho Fjalekalimin</span>
                <i class="fa fa-lock" aria-hidden="true"></i>
              </button>
              <button v-if="userType === 'client' || userType==='agent'"
                class="tablinks"
                onclick="yearList(event, 'referrals')"
              >
                <span>Të referuarit</span>
                <i class="fa fa-lock" aria-hidden="true"></i>
              </button>
            </div>
            <div id="editProfile" class="tabcontent tab-style" style="display: none;">
              <form class="account-form">
                <div class="form-group">
                  <label>Të dhënat personale</label>
                  <input
                    type="text"
                    placeholder="emri"
                    :value="firstName"
                    @input="getFirstName"
                    required
                  >
                  <input
                    type="text"
                    placeholder="mbiemri"
                    :value="lastName"
                    @input="getLastName"
                    required
                  >
                  <input type="email" placeholder="email" :value="email" @input="getEmail" required>
                  <input
                    type="text"
                    placeholder="nr i telefonit"
                    :value="phoneNumber"
                    @input="getPhoneNumber"
                    required
                  >
                  <input
                    type="number"
                    placeholder="ID personale"
                    :value="personalId"
                    @input="getPersonalId"
                    required
                  >
                </div>
                <div v-if="personalDataChangeMessage">
                  <p
                    v-if="personalDataChangeMessage === 'Te dhenat u ruajten me sukses.'"
                    style="color: green"
                  >Te dhenat u ruajten me sukses.</p>
                  <p
                    v-if="personalDataChangeMessage.includes('zbraz')"
                    style="color: red"
                  >{{ personalDataChangeMessage[0].toUpperCase() + personalDataChangeMessage.substring(1) }}</p>

                  <p
                    v-else-if="personalDataChangeMessage.email"
                    style="color: red"
                  >Email i dhene tashme po perdoret nga nje llogari. Ju lutem jepni nje tjeter email.</p>
                </div>
                <div class="form-group">
                  <button type="submit" @click="updatePersonalData">ruaj</button>
                </div>
              </form>
            </div>
            <div id="passwordChange" class="tabcontent tab-style" style="display: block;">
              <form class="account-form">
                <div class="form-group">
                  <label>Ndryshimi i fjalekalimit</label>
                  <input
                    type="password"
                    placeholder="Fjalekalimi aktual"
                    :value="currentPassword"
                    @input="getCurrentPassword"
                    v-on:focusout="onFocusOut"
                  >
                  <input
                    type="password"
                    placeholder="Fjalekalimi i ri"
                    :value="newPassword"
                    @input="getNewPassword"
                    v-on:focusout="onFocusOut"
                  >
                  <input
                    type="password"
                    placeholder="Perserit fjalekalimin e ri"
                    :value="confirmNewPassword"
                    @input="getConfirmNewPassword"
                    v-on:focusout="onFocusOut"
                  >
                </div>
                <div v-if="passwordChangeMessage">
                  <p
                    v-if="passwordChangeMessage === 'Fjalekalimi u ruajt me sukses.'"
                    style="color: green"
                  >Fjalekalimi u ruajt me sukses.</p>
                  <p
                    v-if="passwordChangeMessage.old_password"
                    style="color: red"
                  >Fjalekalimi i gabuar</p>
                </div>

                <div class="form-group">
                  <button type="submit" @click="updatePassword">ruaj</button>
                </div>
              </form>
            </div>
            <div id="invoices" class="tabcontent tab-style" style="display: none;">
              <table>
                <thead>
                  <tr>
                    <th>Shuma e paguar</th>
                    <th>Pagesa u bë</th>
                    <th>Data dhe ora</th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    v-for="payment in payments.filter(x => x.approved === true)"
                    :key="payment.approved_at">
                    <th v-if="payment.user.user_type === 'agent'">FALAS</th>
                    <th v-else>{{ payment.amount }} Euro</th>
                    <th v-if="payment.user.user_type === 'agent'"></th>
                    <th v-else>{{ payment.payment_type.charAt(0).toUpperCase() + payment.payment_type.slice(1) }}</th>
                    <th>{{ payment.approved_at | moment("DD.MM.YYYY - HH:mm") }}</th>
                  </tr>
                </tbody>
              </table>
              <!-- <span class="sum">{{ payments.map(payment => payment.amount).reduce((a, b) => a + b, 0) }} Euro</span> -->
            </div>
            <div id="subscribe" class="tabcontent package tab-style" style="display: none;" v-if="currentSubscription.package_id">
              <h2>{{ currentSubscription.paketa.name }}</h2>
              <hr>
              <ul>
                <li v-if="currentSubscription.package_id===4">
                  <p>Autobartje 24/7 kudo brenda Kosovës.</p>
                  <img src="/img/check.svg">
                </li>
                <li v-if="currentSubscription.package_id===5">
                  <p>Autobartje 24/7 kudo brenda Kosovës, Shqiperisë, Maqedonisë Veriore, Serbisë dhe Malit të Zi.</p>
                  <img src="/img/check.svg">
                </li>
                <li v-if="currentSubscription.package_id===6 || currentSubscription.package_id===7">
                  <p>Autobartje 24/7 kudo brenda Kosovës, Shqiperisë, Maqedonisë veriore, Serbisë dhe Malit të zi dhe të gjitha shteteve të bashkimit Evropian.</p>
                  <img src="/img/check.svg">
                </li>
                <li v-if="currentSubscription.package_id===4 || currentSubscription.package_id===7">
                  <p>Transport të automjetit në servisin me të afërt të autorizuar ose deri në destinacionin e kërkuar nga i anëtarësuari.</p>
                  <img src="/img/check.svg">
                </li>
                <li v-if="currentSubscription.package_id===5 || currentSubscription.package_id===6">
                  <p>Transport të automjetit në servisin më të afërt të autorizuar.</p>
                  <img src="/img/check.svg">
                </li>
              </ul>
              <h5>
                {{ currentSubscription.subscription_plan === 'annual' ? currentSubscription.paketa.annual_price : currentSubscription.paketa.seasonal_price }}€
                <span>{{ currentSubscription.subscription_plan === 'annual' ? 'ne vit' : 'per 60 dite'}}</span>
              </h5>
            </div>
            <div id="referrals" class="tabcontent tab-style" style="display: none;">
              <button class="mb-1 mt-0 referral-link" @click="copyReferralLink">kopjo linkun</button>
              <div class="pt-2">
                <label v-if="referralLink" id="referral-link">Linku i referimit: {{ referralLink }}</label>
                <label v-if="referralLink === null" class="text-danger"><small>Momentalisht nuk keni link valid!</small></label>
              </div>
              <label v-if="referralLink" class="mb-4 p-0">Referral Code: {{ referralLink.split('=')[1]}}</label>

              <table v-if="referrals.length > 0">
                <thead>
                  <tr>
                    <th>Emri</th>
                    <th>Mbiemri</th>
                    <th>Email</th>
                    <th>Bonus</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="referral in referrals" :key="referral.id">
                    <th>{{ referral.referred_user.first_name }}</th>
                    <th>{{ referral.referred_user.last_name }}</th>
                    <th>{{ referral.referred_user.email }}</th>
                    <th>{{ referral.value }}</th>
                  </tr>
                  <tr>
                    <th colspan="3" class="text-right">Total Bonus:</th>
                    <th>{{ totalBonus }} €</th>
                  </tr>
                </tbody>
              </table>
              <div v-else>
                Për momentin nuk keni referime aktive!
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <Footer></Footer>
  </div>
</template>

<style src="@/assets/client/css/main.css">
</style>

<script>
import Header from "@/components/Header.vue";

import { mapGetters } from "vuex";
import "moment";

export default {
  name: "Account",
  components: {
    Header,
  },
  methods: {
    copyReferralLink() {
      this.$store.dispatch("account/getReferralLink").then((response) => {
        navigator.clipboard.writeText(response)
            .then(() => {
              alert('Linku u kopjua me sukses!');
            })
            .catch(() => {
              alert('Linku nuk u kopjua!');
            })
      });
    },
    getFirstName(e) {
      this.$store.dispatch("account/getFirstName", e.target.value);
    },
    getLastName(e) {
      this.$store.dispatch("account/getLastName", e.target.value);
    },
    getEmail(e) {
      this.$store.dispatch("account/getEmail", e.target.value);
    },
    getPhoneNumber(e) {
      this.$store.dispatch("account/getPhoneNumber", e.target.value);
    },
    getPersonalId(e) {
      this.$store.dispatch("account/getPersonalId", e.target.value);
    },
    getCurrentPassword(e) {
      this.$store.dispatch("account/getCurrentPassword", e.target.value);
    },
    getNewPassword(e) {
      this.$store.dispatch("account/getNewPassword", e.target.value);
    },
    getConfirmNewPassword(e) {
      this.$store.dispatch("account/getConfirmNewPassword", e.target.value);
    },
    updatePersonalData(e) {
      e.preventDefault();
      this.$store.dispatch("account/updatePersonalData");
    },
    updatePassword(e) {
      e.preventDefault();
      this.$store.dispatch("account/updatePassword");
    },
    onFocusOut(e) {
      // if (!e.target.value) {
      //   e.target.style.border = "1px solid red";
      //   e.target.style.borderRadius = "3px";
      // } else {
      //   e.target.style.border = "1px solid #e2e5e8";
      //   e.target.style.padding = "15px 20px";
      // }
    }
  },
  computed: {
    ...mapGetters({
      firstName: "account/firstName",
      userType: "account/userType",
      lastName: "account/lastName",
      email: "account/email",
      phoneNumber: "account/phoneNumber",
      personalId: "account/personalId",
      currentPassword: "account/currentPassword",
      newPassword: "account/newPassword",
      confirmNewPassword: "account/confirmNewPassword",
      payments: "account/payments",
      currentSubscription: "account/currentSubscription",
      passwordChangeMessage: "account/passwordChangeMessage",
      personalDataChangeMessage: "account/personalDataChangeMessage",
      personalDataEmptyFields: "account/personalDataEmptyFields",
      referrals: "account/referrals",
      referralLink: "account/referralLink"
    }),
    totalBonus() {
      return this.$store.state.account.total_bonus.toFixed(2);
    },
  },
  beforeMount() {
    this.$store.dispatch("account/getPayments");
    this.$store.dispatch("account/getCurrentSubscription");
  }
};
</script>
